import {
  MDBAlert,
  MDBBtn,
  MDBIcon,
  MDBModalFooter,
  MDBSelect,
  MDBSpinner,
  MDBTable,
  MDBTableBody,
  MDBTableHead,
} from "mdb-react-ui-kit";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

import { useForm } from "react-hook-form";
import { useNavigate } from "react-router";
import {
  editRouingUser,
  getMisc,
  getUserCallRoute,
} from "../../../apiclients/streamsapi_bridge";
import PopupLoader from "../../../views/popups/PopupLoader";
import CallRouting from "../../../views/popups/users/CallRouting";
import DeleteRoutingPlan from "../../../views/popups/users/DeleteRoutingPlan";
import CRPlans from "../../CRPlans";
import SaveChanges from "../../topviews/saveCancel";
import UserScheduleRouting from "./UserScheduleRouting";
import PopupLoaderNew from "../../../views/popups/PopupLoaderNew";
import { useAdminContext } from "../../adminstore/Admin-Context";

const UserCallRouting = ({
  useragent,
  isDisabled,
  setErrorMessage,
  setRerender,
  // greetingInfo,
  setEdited,
  isActive,
}) => {
  const { t, i18n } = useTranslation();

  const [selectedValue, setSelectedValue] = useState(1);

  const handleRadioChange = (event) => {
    setSelectedValue(event.target.value);
  };
  const [routingPlans, setRoutingPlans] = useState([]);
  const [activeRoutingPlan, setActiveRoutingPlan] = useState("");
  const [activeRoutingPlanInfo, setActiveRoutingPlanInfo] = useState({});
  const [viewRoutingPlan, setViewRoutingPlan] = useState(false);
  const [addRoutingPlan, setAddRoutingPlan] = useState(false);
  const [deleteRoutingPlan, setDeleteRoutingPlan] = useState(false);
  const [specificDialPlanId, setSpecificDialPlanId] = useState(0);
  const [viewDialPlanId, setViewDialPlanId] = useState(0);
  const [useragentid, setUserAgentId] = useState(null);
  const [error, setError] = useState(null);
  const [addDialPlans, setAddDialPlans] = useState([]);
  const [reloadPlan, setReloadPlan] = useState(false);
  const navigate = useNavigate();
  const [tzId, setTZId] = useState(0);
  const [plan, setPlan] = useState({});
  // const [isCustomPlan, setIsCustomPlan] = useState(false);
  const [clonePlanInfo, setClonePlanInfo] = useState({});
  const [deletePlanParam, setDeletePlanParam] = useState({});
  const [successMessage, setSuccessMessage] = useState("");
  const [message, setMessage] = useState([]);
  const [isloading, setIsloading] = useState(false);
  const callRouteRef = useRef(null);
  const [isChildDirty, setIsChildDirty] = useState(false);
  const [weeklyPlans, setweeklyPlans] = useState([]);
  const [deviceExternalNum, setDeviceExternalNum] = useState([]);
  const [callerids, setCallerids] = useState([]);
  const [createRoutingPlan, setCreateRoutingPlan] = useState(false);
  const createToggle = () => setCreateRoutingPlan(!createRoutingPlan);
  const [editWarning, seteditWarning] = useState(false);
  const warningToggle = () => seteditWarning(!editWarning);
  const [emessage, setEMessage] = useState("");
  const [emptyDeviceIndex, setemptyDeviceIndex] = useState([]);
  const [greetingInfo, setgreetingInfo] = useState({});

  useEffect(() => {
    if (successMessage) {
      setMessage(true);
      setTimeout(() => {
        setMessage(false);
        setSuccessMessage(""); // Clear the success message in the parent component
      }, 5000);
    }
  }, [successMessage]);

  const [planNames, setPlanNames] = useState("");

  async function getPlanName() {
    console.log(sessionStorage.getItem("admin_session"));
    const response = await getMisc(
      JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      { misc: ["dialplan_name"], agentid: useragentid }
    );
    console.log(response);
    if (!response.json) {
      const message = `An error has occured: ${response.statusText}`;
      return;
    }
    const tdata = await response.json();
    if (!tdata) {
      window.alert(`info with id  not found`);
      navigate("/");
    }
    console.log(tdata);
    console.log("JSon value is ::::::::1111:::::: " + JSON.stringify(tdata));
    setPlanNames(tdata.misc.dialplan_name ?? "");
  }

  async function toggleAddRouting(e) {
    if (allowToSave) {
      warningToggle();
    } else {
      await getPlanName();
      setAddRoutingPlan(!addRoutingPlan);
    }
  }
  function toggleDeleteRouting() {
    setDeleteRoutingPlan(!deleteRoutingPlan);
  }
  const [editSchedule, setEditSchedule] = useState(false);
  const editScheduleToggle = () => setEditSchedule(!editSchedule);

  const handleEditWeekly = (event) => {
    let weeklyPlansInfo = [];
    let weekplanss = [];
    if (!weeklyPlans || weeklyPlans.length === 0) {
      for (let i = 1; i <= 7; i++) {
        // const week = {
        //   dial_planid: parseInt(twentyFourPlan),
        //   week_id: i,
        // };
        const weekPlann = {
          day: i,
          plan_id: parseInt(twentyFourPlan),
        };
        // weeklyPlansInfo.push(week);
        weekplanss.push(weekPlann);
      }
      setweeklyPlans(weekplanss);
      // setAddDialPlans(weeklyPlansInfo);
    }
    // else {
    //   weeklyPlans.forEach((item) => {
    //     const week = {
    //       dial_planid: parseInt(item.plan_id),
    //       week_id: parseInt(item.day),
    //     };
    //     weeklyPlansInfo.push(week);
    //   });
    //   setAddDialPlans(weeklyPlansInfo);
    // }

    editScheduleToggle();
  };

  const handleDeletePlan = (planObj) => {
    if (allowToSave) {
      warningToggle();
    } else {
      setDeletePlanParam({
        agentid: useragentid,
        dialplanid: planObj.dial_planid,
        name: planObj.name,
      });
      toggleDeleteRouting();
    }
  };

  const toggleViewRouting = (dialplanid, itemplan) => {
    setViewDialPlanId(parseInt(dialplanid));
    setViewRoutingPlan(!viewRoutingPlan);
    // setIsCustomPlan(itemplan.is_custom);
    setPlan(itemplan);
  };
  const { register, handleSubmit, formState, setValue, getValues, reset } =
    useForm({
      defaultValues: {
        call_schedule: [
          {
            dial_planid: 393,
          },
        ],
        issched_days: false,
        tzid: 0,
      },
    });
  const [timezones, setTimeZones] = useState([]);
  const { isDirty, dirtyFields } = formState;
  const [twentyFourPlan, setTwentyFourPlan] = useState(393);
  const [defaultValuess, setDefaultValuess] = useState({});
  const streamReq = JSON.parse(
    sessionStorage.getItem("admin_session")
  )?.isStreamReq;
  const isstreamsReq = streamReq && streamReq === 1 ? true : false;

  const isParentFieldChanged =
    Object.keys(dirtyFields).length === 0 ? false : true;
  // const allowToSave = isDirty || isChildDirty;
  const allowToSave = useMemo(
    () => isParentFieldChanged || isChildDirty,
    [isParentFieldChanged, isChildDirty]
  );

  const onSubmit = async (data) => {
    let modifiedField = {};
    if (isDirty) {
      const dirtyFields = formState.dirtyFields;
      for (const field of Object.keys(dirtyFields)) {
        if (dirtyFields[field] && data.hasOwnProperty(field)) {
          modifiedField[field] = data[field];
        }
      }
      if (modifiedField) {
        modifiedField.reqid = 33;
        modifiedField.siteid = JSON.parse(
          sessionStorage.getItem("admin_session")
        ).siteid;
        modifiedField.agentid = useragent;
        modifiedField.issched_days = data.issched_days;
        console.log(JSON.stringify(modifiedField));

        let saverep = await editRouingUser(modifiedField);
        let saverepeMsg = await saverep.json();
        if (saverepeMsg.status && saverepeMsg.status == "success") {
          setRerender(true);
          setSuccessMessage(saverepeMsg.message);
        } else {
          if (saverepeMsg.message?.errors) {
            saverepeMsg.message.errors.forEach((err) => {
              if (err.param_name === "logined_user") {
                setErrorMessage(err.message);
              }
              setError(err.param_name, {
                type: "server",
                message: err.message,
              });
              const fieldElement = document.querySelector(
                `input[name="${err.param_name}"]`
              );
              if (fieldElement) {
                fieldElement.focus();
                fieldElement.scrollIntoView({ behavior: "smooth" });
              }
            });
          }
        }
        //if (saverep.status === 200) {
        setAddDialPlans([]);
        setReloadPlan(true);
        // }
      }
    }
  };

  useEffect(() => {
    async function getCallRoutes() {
      setIsloading(true);
      let response = await getUserCallRoute(
        JSON.parse(sessionStorage.getItem("admin_session")).siteid,
        useragent
      );
      setIsloading(false);
      try {
        if (response) {
          const callroute = await response.json();
          console.log(`cal routing JSON :::::: ${JSON.stringify(callroute)}`);
          // alert("Call ROuting Plan ::::::: "+JSON.stringify(callroute.callrouting?.routing_plan));
          setRoutingPlans(callroute.callrouting?.routing_plan ?? []);
          setActiveRoutingPlan(
            callroute.callrouting?.active_routing_plan?.title ?? []
          );

          const deviceList =
            callroute.callrouting?.active_routing_plan?.devices ?? [];

          const routingPlns = callroute.callrouting?.routing_plan ?? [];
          const activePlanid =
            callroute.callrouting?.active_routing_plan?.dial_planid != undefined
              ? callroute.callrouting?.active_routing_plan?.dial_planid
              : 393;
          setSpecificDialPlanId(parseInt(activePlanid));
          const specific = routingPlns.find(
            (plan) => plan.dial_planid === activePlanid
          );
          const isCustom = specific?.is_custom ?? false;
          const transformData =
            callroute?.callrouting?.active_routing_plan?.devices.reduce(
              (acc, device) => {
                const sequenceIndex = device.seq - 1;
                const deviceData = {
                  deviceid: device.device_id,
                  name: device.device_name,
                  ftime: device.from_time,
                  ttime: device.to_time,
                  is24: device.twentyFourEnabled,
                  external_num: device?.external_num ?? "",
                  device_type: device?.device_type,
                  callerid_pass_flag: device?.callerid_pass_flag ?? true,
                  callerid_pass: device?.callerid_pass + "",
                };

                if (!acc.sequences[sequenceIndex]) {
                  acc.sequences[sequenceIndex] = {
                    name: `seq${device.seq}`,
                    oldseq: `seq${device.seq}`,
                    ringtime: device.ring_secs,
                    devices: [deviceData],
                  };
                } else {
                  acc.sequences[sequenceIndex].devices.push(deviceData);
                }
                return acc;
              },
              {
                name: callroute?.callrouting?.active_routing_plan?.title,
                dialplanid:
                  callroute?.callrouting?.active_routing_plan?.dial_planid,
                issystemroute: !isCustom,
                sequences: [],
              }
            );
          setActiveRoutingPlanInfo(transformData);
          const weekly =
            callroute?.callrouting?.call_schedule?.weekly_plans ?? [];
          setTZId(callroute?.callrouting?.call_schedule?.tz_id ?? 0);
          if (weekly && weekly.length > 0) {
            setSelectedValue(2);
            setweeklyPlans(weekly);
          } else {
            setSelectedValue(1);
            setweeklyPlans([]);
          }
          setTwentyFourPlan(
            callroute.callrouting?.active_routing_plan?.dial_planid !==
              undefined
              ? callroute.callrouting.active_routing_plan.dial_planid
              : 393
          );
          setgreetingInfo(callroute?.callrouting?.greetings ?? {});

          setDefaultValuess({
            call_schedule: [],
            issched_days: weekly && weekly.length > 0 ? true : false,
            tzid: callroute?.callrouting?.call_schedule?.tz_id ?? 0,
          });
          setUserAgentId(useragent);
          setReloadPlan(false);
        }
      } catch (e) {
        console.log(`erorr in getCall Routes:${useragent}::` + e);
      }
    }
    if (
      ((useragent !== undefined && useragent != "") || reloadPlan) &&
      isActive
    ) {
      setEMessage("");
      setemptyDeviceIndex([]);
      getCallRoutes();
    }
  }, [useragent, isActive, reloadPlan]);

  useEffect(() => {
    if (Object.keys(defaultValuess).length !== 0) reset(defaultValuess);
  }, [defaultValuess]);

  useEffect(() => {
    async function fetchTimeZoneData() {
      console.log(sessionStorage.getItem("admin_session"));
      const response = await getMisc(
        JSON.parse(sessionStorage.getItem("admin_session")).siteid,
        { misc: ["timezone"] }
      );
      if (!response.json) {
        const message = `An error has occured: ${response.statusText}`;
        return;
      }
      const tdata = await response.json();
      if (!tdata) {
        window.alert(`info with id  not found`);
        navigate("/");
      }
      let timezoneOptions = tdata?.misc?.timezone ?? [];
      setTimeZones(
        timezoneOptions.map((item) => {
          const [location, offset] = item.timezone.split("  ");
          return {
            text: location,
            secondaryText: offset,
            value: parseInt(item.tid),
          };
        })
      );
    }

    fetchTimeZoneData();
  }, []);

  async function updatePlanValue(dialid, redioOption, weekid) {
    let updateDialPlan = [];
    if (redioOption && redioOption === "twentyFourPlan") {
      let newPlan = {};
      if (selectedValue === 2) {
        const today = new Date();
        const jsDay = today.getDay();
        const adjustedDay = jsDay === 0 ? 1 : jsDay + 1;

        newPlan = {
          dial_planid: parseInt(dialid),
          week_id: parseInt(adjustedDay),
        };

        setValue("issched_days", true, { shouldDirty: true });
      } else {
        newPlan = {
          dial_planid: parseInt(dialid),
        };
        setValue("issched_days", false, { shouldDirty: true });
      }
      updateDialPlan = [newPlan];
    } else {
      setValue("issched_days", true, { shouldDirty: true });
      updateDialPlan = [...addDialPlans];
    }
    setValue("call_schedule", Array.from(updateDialPlan), {
      shouldDirty: true,
    });
  }

  useEffect(() => {
    setEdited(allowToSave);
  }, [allowToSave]);

  async function createPlan() {
    if (allowToSave) {
      warningToggle();
    } else {
      await getPlanName();
      createToggle();
    }
  }

  function closeSave(e) {
    // navigate("/userlanding");
    setEdited(false);
    setTwentyFourPlan(null);
    setReloadPlan(true);
  }

  const onAddPlan = (planObj) => {
    setRoutingPlans((prev) => [...prev, planObj]);
  };

  const handleClonePlan = (clonePlanObj) => {
    setClonePlanInfo(clonePlanObj);
    setAddRoutingPlan(!addRoutingPlan);
  };

  const handleDeleteRoute = (deletePlanid) => {
    const updatePlan = routingPlans.filter(
      (item) => item.dial_planid != deletePlanid
    );
    setRoutingPlans(updatePlan);
  };

  function handleClick() {
    callRouteRef.current.click();
  }

  const [selectedOption, setSelectedOption] = useState("");

  const handleSelectChange = (obj) => {
    obj.preventDefault();
    console.log("Selected value:", obj.target.value);
    setSelectedValue(parseInt(obj.target.value));
    if (parseInt(obj.target.value) === 1) {
      setValue("issched_days", false, { shouldDirty: true });
      const newPlan = {
        dial_planid: parseInt(twentyFourPlan),
      };
      setValue("call_schedule", [newPlan], { shouldDirty: true });
    }
  };

  useEffect(() => {
    if (useragentid && useragentid != "" && isActive) {
      getDeviceExternalNumber();
      getCallerIds();
    }
  }, [useragentid, isActive]);

  // const navigate = useNavigate();

  async function getDeviceExternalNumber() {
    console.log(sessionStorage.getItem("admin_session"));
    const response = await getMisc(
      JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      { misc: ["devices"], agentid: useragentid }
    );
    console.log(response);
    if (!response.json) {
      const message = `An error has occured: ${response.statusText}`;
      return;
    }
    const tdata = await response.json();
    if (!tdata) {
      window.alert(`info with id  not found`);
      navigate("/");
    }
    console.log(tdata);
    console.log(
      "mmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmm  ::::: " +
      JSON.stringify(tdata?.misc?.devicesList)
    );
    setDeviceExternalNum(tdata?.misc?.devicesList ?? []);
  }
  async function getCallerIds() {
    console.log(sessionStorage.getItem("admin_session"));
    const response = await getMisc(
      JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      { misc: ["callerid_list"] }
    );
    if (!response.json) {
      const message = `An error has occured: ${response.statusText}`;
      return;
    }
    const tdata = await response.json();
    if (!tdata) {
      window.alert(`info with id  not found`);
      //navigate("/");
    }
    setCallerids(tdata?.misc?.callerid_list ?? []);
  }

  // console.log(timezones,"###################")

  return (
    <>
      <div className="w-100">
        {isloading && (
          <>
            <div className="loadingclass">
              <MDBBtn disabled>
                <MDBSpinner
                  size="sm"
                  role="status"
                  tag="span"
                  className="me-2"
                />
                Loading...
              </MDBBtn>
            </div>
          </>
        )}
        {/* <div
          className={`d-flex justify-content-between align-items-center w-50 flex-column-sm mt-3 ${isDisabled && "disabled-form cursor-notAllowed"}`}
          title={isDisabled && "Do not have privilege to edit user"}
        >
          <strong className="fs-5">{t("CallSchedule")}</strong>
          <div className="d-flex align-items-center">
            <div className="d-flex align-items-center">
              <MDBRadio
                type="radio"
                name="inlineRadio"
                id="inlineRadio1"
                value="option1"
                checked={selectedValue === "option1"}
                onChange={handleRadioChange}
                label="24/7"
              /> 
              {selectedValue === "option1" && (
                <div className="phoneselect ms-4 ">
                  <CRPlans
                    routingPlans={routingPlans}
                    activePlan={twentyFourPlan}
                    updatePlanValue={updatePlanValue}
                    dayIndex="0"
                  />
                </div>
              )}
            </div>
            <div className="d-flex-sm mt-sm-2 ms-4">
              <MDBRadio
                type="radio"
                name="inlineRadio"
                id="inlineRadio2"
                value="option2"
                checked={selectedValue === "option2"}
                onChange={handleRadioChange}
                label={t("ScheduleDays")}
              />
            </div>
          </div>
        </div>

        {selectedValue === "option2" && (
          <>
            <div className="d-flex align-items-start justify-content-center flex-column">
              <CRScheduleDays
                datelabel={t("monday")}
                routingPlans={routingPlans}
                activePlan={mondayPlan}
                updatePlanValue={updatePlanValue}
                dayIndex="2"
              />
              <CRScheduleDays
                datelabel={t("tuesday")}
                routingPlans={routingPlans}
                activePlan={tuesPlan}
                updatePlanValue={updatePlanValue}
                dayIndex="3"
              />
              <CRScheduleDays
                datelabel={t("wednesday")}
                routingPlans={routingPlans}
                activePlan={wedPlan}
                updatePlanValue={updatePlanValue}
                dayIndex="4"
              />
              <CRScheduleDays
                datelabel={t("thursday")}
                routingPlans={routingPlans}
                activePlan={thusPlan}
                updatePlanValue={updatePlanValue}
                dayIndex="5"
              />
              <CRScheduleDays
                datelabel={t("friday")}
                routingPlans={routingPlans}
                activePlan={friPlan}
                updatePlanValue={updatePlanValue}
                dayIndex="6"
              />
              <CRScheduleDays
                datelabel={t("saturday")}
                routingPlans={routingPlans}
                activePlan={satPlan}
                updatePlanValue={updatePlanValue}
                dayIndex="7"
              />
              <CRScheduleDays
                datelabel={t("sunday")}
                routingPlans={routingPlans}
                activePlan={sundayPlan}
                updatePlanValue={updatePlanValue}
                dayIndex="1"
              /> 
              <div
                className={`d-flex align-items-center justify-content-between w-50 mt-3${isDisabled && "disabled-form cursor-notAllowed"
                  }`}
                title={isDisabled && "Do not have previlege to edit user"}
              >
                <label>{t("timezone")}</label>
                <select
                  value={tzId}
                  className="form-control form-select selectname mt-2 w-60"
                  name="San Jose"
                  onChange={(e) => {
                    setTZId(parseInt(e.target.value));
                    setValue("tzid", parseInt(e.target.value), {
                      shouldDirty: true,
                    });
                  }}
                >
                  {timezones &&
                    timezones.map((item) => (
                      <>
                        <option key={item.tid} value={item.tid}>
                          {item.timezone}
                        </option>
                      </>
                    ))}
                </select>
              </div>
            </div>
          </>
        )} */}

        <div
          className={`d-flex align-items-center mt-3 ${isDisabled && !isstreamsReq && "disabled-form cursor-notAllowed"
            }`}
          title={
            isDisabled && !isstreamsReq && "Do not have previlege to edit user"
          }
        >
          <div className="d-flex align-items-center">
            <strong className="fs-5 me-2">
              {t("ActivePlan")}:
              <span className="text-secondary fw-bold">
                {/* {activeRoutingPlan ? activeRoutingPlan : ""} */}
              </span>
            </strong>

            <div className="phoneselect">
              <CRPlans
                routingPlans={routingPlans}
                activePlan={twentyFourPlan}
                updatePlanValue={updatePlanValue}
                createPlan={createPlan}
                isCreatePlan={true}
                dayIndex="0"
              />
            </div>
          </div>
          <div className="d-flex align-items-center ms-4">
            <strong className="fs-5 me-2">
              {t("schedule")}:
              <span className="text-secondary fw-bold">
                {/* {activeRoutingPlan ? activeRoutingPlan : ""} */}
              </span>
            </strong>
            <div className="position-relative">
              <select
                style={{ width: "210px" }}
                className="form-control form-select"
                name="San Jose"
                value={selectedValue}
                onChange={(e) => handleSelectChange(e)}
              >
                <option value={1}>24/7</option>
                <option value={2}>Weekly</option>
              </select>
              {selectedValue === 2 && (
                <a
                  onClick={(e) => {
                    handleEditWeekly(e);
                  }}
                  className="mt-1 cursor-pointer position-absolute end-0"
                >
                  Edit
                </a>
              )}
            </div>
          </div>
          <div className="d-flex align-items-center ms-4">
            <strong className="fs-5 me-2">
              {t("timezone")}:
              <span className="text-secondary fw-bold">
                {/* {activeRoutingPlan ? activeRoutingPlan : ""} */}
              </span>
            </strong>

            <MDBSelect
              style={{ width: "210px" }}
              search
              className="timeZone"
              label={false}
              data={timezones}
              value={parseInt(tzId)}
              onChange={(e) => {
                if (e && e.value) {
                  const selectedValue = parseInt(e.value);
                  setTZId(selectedValue);
                  setValue("tzid", selectedValue, {
                    shouldDirty: true,
                  });
                }
              }}
            />

            {/* <select
              value={parseInt(tzId)}
              className="form-control form-select selectname w-60"
              name="San Jose"
              onChange={(e) => {
                setTZId(parseInt(e.target.value));
                setValue("tzid", parseInt(e.target.value), {
                  shouldDirty: true,
                });
              }}
            >
              {timezones &&
                timezones.map((item) => (
                  <>
                    <option key={parseInt(item.tid)} value={parseInt(item.tid)}>
                      {item.timezone}
                    </option>
                  </>
                ))}
            </select> */}
          </div>
          {/* {activeRoutingPlanInfo && !activeRoutingPlanInfo.issystemroute && (
            <>
              {" "}
              <div className="d-flex">
                <MDBBtn
                  className="ripple ripple-surface btn btn-primary"
                >
                  <MDBIcon fas icon="plus" size="sm" /> {t("Addsequence")}
                </MDBBtn>
              </div>
            </>
          )} */}
        </div>
        <div
          className={`d-flex justify-content-center mt-4 flex-column-sm ip-routing-plan ip-align-items-baseline ip-align-center align-items-center
         ${isDisabled && !isstreamsReq && "disabled-form cursor-notAllowed"}`}
        >
          <CallRouting
            isadd={false}
            onClose={null}
            planInfo={activeRoutingPlanInfo}
            agentid={useragentid}
            addNewPlan={onAddPlan}
            isView={false}
            // isCustomPlan={false}
            clonePlan={handleClonePlan}
            setSuccessMessage={setSuccessMessage}
            isDisabled={null}
            setIsChildDirty={setIsChildDirty}
            parentDirtyFields={dirtyFields}
            parentgetValues={getValues}
            setRerender={setRerender}
            setErrorMessage={setErrorMessage}
            setAddDialPlans={setAddDialPlans}
            setReloadPlan={setReloadPlan}
            useragent={useragent}
            dialPlanid={specificDialPlanId}
            deviceExternalNum={deviceExternalNum}
            callerids={callerids}
            createPlanFlag={false}
            planNames={null}
            greetingInfo={greetingInfo}
            emessage={emessage}
            setEMessage={setEMessage}
            emptyDeviceIndex={emptyDeviceIndex}
            setemptyDeviceIndex={setemptyDeviceIndex}
             key={specificDialPlanId}
            ref={callRouteRef}
          />
        </div>

        <div className="w-100 pe-3">
          <div className="add-numbermain">
            <div className="tel-numbers">
              <strong className="fs-5">{t("RoutingPlans")}</strong>
            </div>
            <div
              className={`d-flex ${isDisabled && !isstreamsReq && "disabled-form cursor-notAllowed"
                }`}
              title={
                isDisabled &&
                !isstreamsReq &&
                "Do not have previlege to edit user"
              }
            >
              <MDBBtn
                className="ripple ripple-surface btn btn-primary"
                onClick={(e) => toggleAddRouting(e)}
              >
                <MDBIcon fas icon="plus" size="sm" /> {t("AddRoutingPlan")}
              </MDBBtn>
            </div>
          </div>
          <MDBTable hover className="mt-2">
            <MDBTableHead>
              <tr>
                <th scope="col" className="w-90">
                  {t("name")}
                </th>
                <th scope="col" className="text-center">
                  {t("Remove")}
                </th>
              </tr>
            </MDBTableHead>
            <MDBTableBody>
              {routingPlans &&
                routingPlans.map((items) => (
                  <>
                    {parseInt(items.dial_planid) !== 0 && (
                      <tr
                        style={{ cursor: "pointer" }}
                        onClick={(e) => {
                          e.preventDefault(); // Prevent the form submission
                          toggleViewRouting(items.dial_planid, items); // Open the modal
                        }}
                      >
                        <td scope="row">{items.name}</td>
                        <td className="text-center">
                          {routingPlans.length > 1 &&
                            parseInt(items.dial_planid) !==
                            parseInt(twentyFourPlan) && (
                              <i
                                className="fas fa-xmark ms-4 text-primary"
                                onClick={(e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  handleDeletePlan(items);
                                }}
                              ></i>
                            )}
                        </td>
                      </tr>
                    )}
                  </>
                ))}
            </MDBTableBody>
          </MDBTable>

          <div className="routing-border"></div>
        </div>
      </div>
      {allowToSave && (
        <SaveChanges
          onClose={(e) => {
            closeSave(e);
            setEMessage("");
            setemptyDeviceIndex([]);
          }}
          isdirtyFields={allowToSave}
          onSave={handleSubmit(handleClick)}
        />
      )}
      {viewRoutingPlan && (
        <PopupLoader
          size="xl"
          className="modal-xl modal-auto"
          title={t("EditRoutingPlan")}
          content={
            <CallRouting
              isadd={false}
              onClose={(e) => setViewRoutingPlan(!viewRoutingPlan)}
              planInfo={null}
              agentid={useragentid}
              plan={plan}
              addNewPlan={onAddPlan}
              isView={true}
              // isCustomPlan={isCustomPlan}
              clonePlan={handleClonePlan}
              setSuccessMessage={setSuccessMessage}
              isDisabled={isDisabled}
              setIsChildDirty={null}
              parentDirtyFields={null}
              parentgetValues={null}
              setRerender={null}
              setErrorMessage={null}
              setAddDialPlans={null}
              setReloadPlan={setReloadPlan}
              useragent={null}
              dialPlanid={viewDialPlanId}
              deviceExternalNum={deviceExternalNum}
              callerids={callerids}
              createPlanFlag={false}
              planNames={null}
              greetingInfo={greetingInfo}
              emessage={emessage}
              setEMessage={setEMessage}
              emptyDeviceIndex={emptyDeviceIndex}
              setemptyDeviceIndex={setemptyDeviceIndex}
              ref={callRouteRef}
            />
          }
          onShow={setViewRoutingPlan}
          onClose={(e) => setViewRoutingPlan(!viewRoutingPlan)}
        />
      )}
      {addRoutingPlan && (
        <PopupLoader
          size="xl"
          className="modal-xl modal-auto"
          title="Add Routing"
          content={
            <CallRouting
              onClose={toggleAddRouting}
              isadd={true}
              planInfo={null}
              agentid={useragentid}
              addNewPlan={onAddPlan}
              isView={false}
              // isCustomPlan={false}
              clonePlan={null}
              clonePlanInfo={clonePlanInfo}
              setSuccessMessage={setSuccessMessage}
              isDisabled={null}
              setIsChildDirty={null}
              parentDirtyFields={null}
              parentgetValues={null}
              setRerender={null}
              setErrorMessage={null}
              setAddDialPlans={null}
              setReloadPlan={setReloadPlan}
              useragent={null}
              dialPlanid={null}
              deviceExternalNum={deviceExternalNum}
              callerids={callerids}
              createPlanFlag={false}
              planNames={planNames}
              greetingInfo={greetingInfo}
              emessage={emessage}
              setEMessage={setEMessage}
              emptyDeviceIndex={emptyDeviceIndex}
              setemptyDeviceIndex={setemptyDeviceIndex}
              setTwentyFourPlan={setTwentyFourPlan}
              ref={callRouteRef}
            />
          }
          onShow={setAddRoutingPlan}
          onClose={toggleAddRouting}
        />
      )}
      {createRoutingPlan && (
        <PopupLoader
          size="xl"
          className="modal-xl modal-auto"
          title="Add Routing"
          content={
            <CallRouting
              onClose={createToggle}
              isadd={true}
              planInfo={null}
              agentid={useragentid}
              addNewPlan={onAddPlan}
              isView={false}
              // isCustomPlan={false}
              clonePlan={null}
              clonePlanInfo={clonePlanInfo}
              setSuccessMessage={setSuccessMessage}
              isDisabled={null}
              setIsChildDirty={null}
              parentDirtyFields={null}
              parentgetValues={null}
              setRerender={setRerender}
              setErrorMessage={null}
              setAddDialPlans={null}
              setReloadPlan={setReloadPlan}
              useragent={null}
              dialPlanid={null}
              deviceExternalNum={deviceExternalNum}
              callerids={callerids}
              createPlanFlag={true}
              planNames={planNames}
              greetingInfo={greetingInfo}
              emessage={emessage}
              setEMessage={setEMessage}
              emptyDeviceIndex={emptyDeviceIndex}
              setemptyDeviceIndex={setemptyDeviceIndex}
              ref={callRouteRef}
            />
          }
          onShow={setCreateRoutingPlan}
          onClose={createToggle}
        />
      )}

      {deleteRoutingPlan && (
        <PopupLoader
          size="md"
          className="modal-xl modal-auto"
          title="Remove Routing"
          content={
            <DeleteRoutingPlan
              onClose={toggleDeleteRouting}
              deletePlanParam={deletePlanParam}
              deletePlanId={handleDeleteRoute}
              setSuccessMessage={setSuccessMessage}
              setReloadPlan={setReloadPlan}
              setTwentyFourPlan={setTwentyFourPlan}
            />
          }
          onShow={setDeleteRoutingPlan}
          onClose={toggleDeleteRouting}
        />
      )}
      {editSchedule && (
        <PopupLoader
          title="Edit Schedule"
          content={
            <UserScheduleRouting
              routingPlans={routingPlans}
              updatePlanValue={updatePlanValue}
              addDialPlans={addDialPlans}
              setAddDialPlans={setAddDialPlans}
              weeklyPlans={weeklyPlans}
              setSelectedValue={setSelectedValue}
              onClose={editScheduleToggle}
            />
          }
          onShow={setEditSchedule}
          onClose={editScheduleToggle}
        />
      )}

      {editWarning && (
        <PopupLoader
          size="md"
          className="modal-xl modal-auto"
          title="Warning"
          content={
            <>
              <div className="d-flex bg-warning bg-opacity-25 p-3 rounded-3 square border border-2 border-warning">
                <MDBIcon
                  fas
                  icon="exclamation-triangle"
                  className="me-3 fs-5 mt-1"
                  color="warning"
                />
                <div>There are unsaved changes. Please Save to continue.</div>
              </div>
              <MDBModalFooter>
                <MDBBtn onClick={(e) => warningToggle()}>{t("ok")}</MDBBtn>
              </MDBModalFooter>
            </>
          }
          onShow={seteditWarning}
          onClose={warningToggle}
        />
      )}

      {successMessage && (
        <MDBAlert
          open
          className="alert-center"
          color="success"
          autohide
          position="bottom-right"
          delay={10000}
        >
          <i className="fas fa-check-circle me-3"></i>
          <span className="alert-msg">{successMessage}</span>
        </MDBAlert>
      )}
    </>
  );
};
export default UserCallRouting;
